<div class="axis-h5">{{ signatureUIData?.signatureArea?.label }}</div>
<form [formGroup]="signatureForm">
  <div class="axis-grid">
    <div class="axis-col-md-auto">
      <axis-tab-wrapper>
        <axis-tab-set [isScroll]="true" (tabChange)="onTabChange($event)">
          <axis-tab heading="Type" [active]="selectedMethod() === 'type'">
            <axis-tab-content>
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-error':
                    signatureForm.get('unSignInputText').value === '' &&
                    signatureForm.get('unSignInputText').touched,
                  'has-axis-required':
                    signatureForm.get('unSignInputText').value === '',
                }"
              >
                <input
                  autocomplete="off"
                  axis-input-clear
                  aria-label="Please Sign"
                  class="axis-form-control signature-box _text-xxlarge _text-bold"
                  type="text"
                  formControlName="unSignInputText"
                />
              </div>
            </axis-tab-content>
          </axis-tab>
          <axis-tab heading="Draw" [active]="selectedMethod() === 'draw'">
            <axis-tab-content>
              <input type="hidden" formControlName="unSignInputDraw" />
              <canvas
                #canvas
                width="700"
                height="150"
                class="signature-box"
              ></canvas>
            </axis-tab-content>
          </axis-tab>
          <axis-tab heading="Image" [active]="selectedMethod() === 'file'">
            <axis-tab-content>
              <div
                class="_display-flex _flex-column _align-items-center _justify-content-center signature-box"
                axis-drag-highlight
                #fileUpload="axis-drag-highlight"
                restrictFiles=".jpeg,.jpg,.png"
                [documentFlag]="true"
                (listChange)="listChange($event)"
                [imagePreview]="true"
              >
                <div [hidden]="!!fileSrc()?.length">Drag a file to upload</div>
                <axis-upload
                  #fileUpload
                  restrictFiles=".jpeg,.jpg,.png"
                  [documentFlag]="true"
                  (listChange)="listChange($event)"
                  [isMulti]="false"
                  [imagePreview]="true"
                  [hidden]="fileSrc()"
                  title="Or choose image files"
                />
                <img
                  [src]="fileSrc()"
                  class="signature-box"
                  [hidden]="!fileSrc().length"
                  alt="Uploaded signature"
                />
              </div>
            </axis-tab-content>
          </axis-tab>
        </axis-tab-set>
      </axis-tab-wrapper>
    </div>
    <div class="axis-col-md _align-self-end">
      <div class="axis-form-group">
        <label class="axis-control-label">{{
          signatureUIData?.signatureArea?.dateLabel
        }}</label>
        <div>
          {{ currentDateTime() | date: "MMM dd yyyy HH:mm:ss 'GMT'" : "GMT" }}
        </div>
      </div>
    </div>
    <div class="axis-col-12">
      <div class="axis-form-group">
        <button axis-button class="kind-link" (click)="clearSignature()">
          <span class="axis-btn-icon-text">{{
            signatureUIData?.signatureArea?.clearLabel
          }}</span>
        </button>
      </div>
    </div>
  </div>
</form>
